module.exports = __webpack_public_path__ + "static/img/质控数据.5b87e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/修饰合成/修饰引物合成/质控数据.png
// module id = B382
// module chunks = 16